import { useMutationWithResultNotification } from 'api/mutations/useMutationWithResultNotification';
import {
  displayErrorArrayNotifications,
  displaySuccessNotification,
} from 'modules/Notifications';
import { unlinkExternalUsersProvider } from 'api/membership';

type UseUnlinkUsersExternalProviderProps = {
  userId: string;
  loginProvider: string;
  providerKey: string;
};

const useUnlinkUsersExternalProvider = (successFb?: () => void) => {
  return useMutationWithResultNotification({
    asyncApiFunction: async ({
      userId,
      loginProvider,
      providerKey,
    }: UseUnlinkUsersExternalProviderProps) => {
      await unlinkExternalUsersProvider(userId, loginProvider, providerKey);
    },
    resetOnResult: true,
    onSuccess: () => {
      successFb && successFb();
      displaySuccessNotification(
        'MyProfile.ProfileSettings.successfullyUnlinkedExternalUsersProvider'
      );
    },
    onErrorArray: (errors) => {
      displayErrorArrayNotifications(
        errors,
        'MyProfile.ProfileSettings.unlinkingExternalUsersProviderWithError'
      );
    },
  });
};

export default useUnlinkUsersExternalProvider;
